/** Independent save lane: access controls never trigger a location autosave. */
function initWorldGateEditor(): void {
    const form = document.querySelector<HTMLFormElement>('[data-ft-world-gate-editor]');
    if (!form || form.dataset.ready) return;
    const sample = form.querySelector<HTMLFieldSetElement>('[data-world-gate-sample]')!;
    const source = form.querySelector<HTMLSelectElement>('[name="source_id"]')!;
    const words = form.querySelector<HTMLInputElement>('[name="sample_words"]')!;
    const status = form.querySelector<HTMLElement>('[data-world-gate-status]')!;
    const button = form.querySelector<HTMLButtonElement>('button[type="submit"]')!;
    let saving = false;
    const sync = (): void => {
        const gated = form.querySelector<HTMLInputElement>('[name="mode"]:checked')?.value === 'sample';
        sample.hidden = !gated;
        sample.disabled = !gated;
        const selected = source.selectedOptions[0];
        form.querySelector<HTMLElement>('[data-world-gate-source-name]')!.textContent = selected?.value ? selected.text : 'the selected source';
        button.disabled = saving || (gated && (!selected?.value || selected.disabled));
    };
    form.addEventListener('change', () => { status.textContent = ''; sync(); });
    form.addEventListener('submit', async (event) => {
        event.preventDefault();
        if (saving || !form.reportValidity()) return;
        saving = true;
        sync();
        status.className = 'small';
        status.textContent = 'Saving…';
        const mode = form.querySelector<HTMLInputElement>('[name="mode"]:checked')!.value;
        // Freeze inputs until readback so a late response cannot overwrite a newer choice.
        const controls = [...form.querySelectorAll<HTMLInputElement | HTMLSelectElement>('input, select')];
        controls.forEach(control => { control.disabled = true; });
        try {
            const response = await fetch(form.dataset.endpoint!, {
                method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ location_id: form.dataset.locationId, mode, source_id: source.value,
                    sample_words: Number(words.value), csrf_token: form.querySelector<HTMLInputElement>('[name="csrf_token"]')!.value }),
            });
            const result = await response.json();
            if (!response.ok || !result.ok) throw new Error(result.error || 'Could not save access.');
            const gate = result.gate;
            form.querySelector<HTMLInputElement>(`[name="mode"][value="${gate.gated ? 'sample' : 'open'}"]`)!.checked = true;
            source.value = gate.source_id;
            words.value = String(gate.sample_words);
            status.className = 'small text-success';
            status.textContent = gate.gated ? 'Access saved — Sample.' : 'Access saved — Open.';
        } catch (error) {
            status.className = 'small text-danger';
            status.textContent = error instanceof Error ? error.message : 'Could not save access.';
        } finally {
            controls.forEach(control => { control.disabled = false; });
            saving = false;
            sync();
        }
    });
    form.dataset.ready = '1';
    sync();
}

if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initWorldGateEditor, { once: true });
else initWorldGateEditor();

export {};
